import React from 'react'
import Select from 'react-select'

export default ({ isShow, filter, onFilterChange, onClearFilter }) => {
  if (!isShow) return null

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 mb-4 shadow-sm">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-3 items-start">
        {/* Check-in Type */}
        <div className="md:col-span-3">
          <Select
            value={filter.checkInType}
            onChange={(value) => {
              if (value !== 'walkin') onFilterChange('walkinCheckInType', null)

              onFilterChange('checkInType', value)
            }}
            placeholder="Check-in Type"
            simpleValue
            options={checkInTypeOptions}
            styles={customSelectStyles}
          />
        </div>

        {/* Passenger Name */}
        <div className="md:col-span-4">
          <input
            type="text"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors text-base"
            value={filter.reservationMainPaxName || ''}
            onChange={(e) =>
              onFilterChange('reservationMainPaxName', e.currentTarget.value)
            }
            placeholder="Passenger Name"
          />
        </div>

        {/* Flight Number */}
        <div className="md:col-span-3">
          <input
            type="text"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors text-base"
            value={filter.flightNumber || ''}
            onChange={(e) =>
              onFilterChange('flightNumber', e.currentTarget.value)
            }
            placeholder="Flight Number"
          />
        </div>

        {/* Clear Filter Button */}
        <div className="md:col-span-2">
          <button
            onClick={onClearFilter}
            className="w-full px-4 py-2 bg-white border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 hover:border-gray-400 transition-colors flex items-center justify-center gap-2 font-medium text-sm"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
            Clear
          </button>
        </div>
      </div>

      {/* Walk-in Type (conditional) */}
      {filter.checkInType === 'walkin' && (
        <div className="grid grid-cols-1 md:grid-cols-12 gap-3 mt-3">
          <div className="md:col-span-3">
            <Select
              value={filter.walkinCheckInType}
              onChange={(value) => onFilterChange('walkinCheckInType', value)}
              placeholder="Walk-in Type"
              simpleValue
              options={walkinCheckInTypeOptions}
              styles={customSelectStyles}
            />
          </div>
        </div>
      )}
    </div>
  )
}

const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '42px',
    borderRadius: '0.5rem',
    borderColor: state.isFocused ? '#aa6326' : '#d1d5db',
    boxShadow: state.isFocused ? '0 0 0 2px rgba(170, 99, 38, 0.2)' : 'none',
    '&:hover': {
      borderColor: state.isFocused ? '#aa6326' : '#9ca3af',
    },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#aa6326'
      : state.isFocused
        ? '#fdf7f0'
        : 'white',
    color: state.isSelected ? 'white' : '#374151',
    '&:active': {
      backgroundColor: '#aa6326',
    },
  }),
}

const checkInTypeOptions = [
  { label: 'Airline', value: 'airline' },
  { label: 'Agent', value: 'agent' },
  { label: 'Walkin', value: 'walkin' },
]

const walkinCheckInTypeOptions = [
  { label: 'Cash', value: 'cash' },
  { label: 'Credit Card', value: 'creditCash' },
  { label: 'Card', value: 'card' },
  { label: 'Others', value: 'others' },
]
